export const DashboardIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.85897 11.2821C9.03231 11.2821 9.21795 12.6974 9.21795 15.641C9.21795 17.1159 9.21795 18.1651 8.59846 18.9333C7.88564 19.8185 6.58821 20 4.85897 20C3.12974 20 1.83231 19.8185 1.11949 18.9333C0.5 18.1651 0.5 17.1169 0.5 15.6667L1.26923 15.641H0.5C0.5 12.6974 0.685641 11.2821 4.85897 11.2821ZM16.141 11.2821C20.3144 11.2821 20.5 12.6974 20.5 15.641C20.5 17.1159 20.5 18.1651 19.8805 18.9333C19.1677 19.8185 17.8703 20 16.141 20C14.4118 20 13.1144 19.8185 12.4015 18.9333C11.7821 18.1651 11.7821 17.1169 11.7821 15.6667L12.5513 15.641H11.7821C11.7821 12.6974 11.9677 11.2821 16.141 11.2821ZM5.07042 12.821L4.85897 12.8205C2.1831 12.8205 2.04588 13.0125 2.03884 15.2585L2.03927 16.1335C2.04413 17.0268 2.07817 17.6721 2.31641 17.9692C2.58821 18.3056 3.39538 18.4615 4.85897 18.4615C6.32256 18.4615 7.12974 18.3046 7.40154 17.9682C7.67949 17.6226 7.67949 16.8021 7.67949 15.6656C7.67949 13.1013 7.67949 12.833 5.07042 12.821ZM16.3525 12.821L16.141 12.8205C13.4652 12.8205 13.3279 13.0125 13.3209 15.2585L13.3213 16.1335C13.3262 17.0268 13.3602 17.6721 13.5985 17.9692C13.8703 18.3056 14.6774 18.4615 16.141 18.4615C17.6046 18.4615 18.4118 18.3046 18.6836 17.9682C18.9615 17.6226 18.9615 16.8021 18.9615 15.6656C18.9615 13.1013 18.9615 12.833 16.3525 12.821ZM4.85897 0C9.03231 0 9.21795 1.41538 9.21795 4.35897C9.21795 5.83385 9.21795 6.88308 8.59846 7.65128C7.88564 8.53641 6.58821 8.71795 4.85897 8.71795C3.12974 8.71795 1.83231 8.53641 1.11949 7.65128C0.5 6.88308 0.5 5.83487 0.5 4.38462L1.26923 4.35897H0.5C0.5 1.41538 0.685641 0 4.85897 0ZM16.141 0C20.3144 0 20.5 1.41538 20.5 4.35897C20.5 5.83385 20.5 6.88308 19.8805 7.65128C19.1677 8.53641 17.8703 8.71795 16.141 8.71795C14.4118 8.71795 13.1144 8.53641 12.4015 7.65128C11.7821 6.88308 11.7821 5.83487 11.7821 4.38462L12.5513 4.35897H11.7821C11.7821 1.41538 11.9677 0 16.141 0ZM5.07042 1.53892L4.85897 1.53846C2.1831 1.53846 2.04588 1.73048 2.03884 3.97646L2.03927 4.85147C2.04413 5.74476 2.07817 6.39004 2.31641 6.68718C2.58821 7.02359 3.39538 7.17949 4.85897 7.17949C6.32256 7.17949 7.12974 7.02256 7.40154 6.68615C7.67949 6.34051 7.67949 5.52 7.67949 4.38359C7.67949 1.81928 7.67949 1.55099 5.07042 1.53892ZM16.3525 1.53892L16.141 1.53846C13.4652 1.53846 13.3279 1.73048 13.3209 3.97646L13.3213 4.85147C13.3262 5.74476 13.3602 6.39004 13.5985 6.68718C13.8703 7.02359 14.6774 7.17949 16.141 7.17949C17.6046 7.17949 18.4118 7.02256 18.6836 6.68615C18.9615 6.34051 18.9615 5.52 18.9615 4.38359C18.9615 1.81928 18.9615 1.55099 16.3525 1.53892Z"
        fill="#27AE60"
      />
    </svg>
  );
};
export const LocationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_807_3129)">
        <path
          d="M5.25 21.75H18.75"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_807_3129">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const SaleIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_807_3140)">
        <path
          d="M16.875 9.75H7.125"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.875 12.75H7.125"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 19.5V5.25C21 5.05109 20.921 4.86032 20.7803 4.71967C20.6397 4.57902 20.4489 4.5 20.25 4.5H3.75C3.55109 4.5 3.36032 4.57902 3.21967 4.71967C3.07902 4.86032 3 5.05109 3 5.25V19.5L6 18L9 19.5L12 18L15 19.5L18 18L21 19.5Z"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_807_3140">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 1 24 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FinishIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#27AE60" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L14.7071 20.7071C14.3166 21.0976 13.6834 21.0976 13.2929 20.7071L9.29289 16.7071C8.90237 16.3166 8.90237 15.6834 9.29289 15.2929C9.68342 14.9024 10.3166 14.9024 10.7071 15.2929L14 18.5858L21.2929 11.2929C21.6834 10.9024 22.3166 10.9024 22.7071 11.2929Z"
        fill="white"
      />
    </svg>
  );
};

export const RejectIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="16" fill="#EB5757" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L14.7071 20.7071C14.3166 21.0976 13.6834 21.0976 13.2929 20.7071L9.29289 16.7071C8.90237 16.3166 8.90237 15.6834 9.29289 15.2929C9.68342 14.9024 10.3166 14.9024 10.7071 15.2929L14 18.5858L21.2929 11.2929C21.6834 10.9024 22.3166 10.9024 22.7071 11.2929Z"
        fill="white"
      />
    </svg>
  );
};

export const CircleIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="30" height="30" rx="15" fill="white" />
      <circle cx="16" cy="16" r="5" fill="#27AE60" />
      <rect
        x="1"
        y="1"
        width="30"
        height="30"
        rx="15"
        stroke="#27AE60"
        stroke-width="2"
      />
    </svg>
  );
};
export const RewardsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_807_3145)">
        <path
          d="M5.25 5.25V10.4156C5.25 14.1375 8.23125 17.2219 11.9531 17.25C12.8435 17.2562 13.7263 17.0862 14.5506 16.7497C15.375 16.4133 16.1247 15.917 16.7564 15.2896C17.3882 14.6622 17.8896 13.916 18.2317 13.094C18.5739 12.272 18.75 11.3904 18.75 10.5V5.25C18.75 5.05109 18.671 4.86032 18.5303 4.71967C18.3897 4.57902 18.1989 4.5 18 4.5H6C5.80109 4.5 5.61032 4.57902 5.46967 4.71967C5.32902 4.86032 5.25 5.05109 5.25 5.25Z"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 21H15"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 17.25V21"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5813 12H19.5C20.2957 12 21.0588 11.6839 21.6214 11.1213C22.184 10.5587 22.5 9.79565 22.5 9V7.5C22.5 7.30109 22.421 7.11032 22.2804 6.96967C22.1397 6.82902 21.949 6.75 21.75 6.75H18.75"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.43748 12H4.4906C3.69495 12 2.93189 11.6839 2.36928 11.1213C1.80667 10.5587 1.4906 9.79565 1.4906 9V7.5C1.4906 7.30109 1.56962 7.11032 1.71027 6.96967C1.85092 6.82902 2.04169 6.75 2.2406 6.75H5.2406"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_807_3145">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UserIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_807_3134)">
        <path
          d="M12 15.75C10.3431 15.75 9 14.4069 9 12.75C9 11.0931 10.3431 9.75 12 9.75C13.6569 9.75 15 11.0931 15 12.75C15 14.4069 13.6569 15.75 12 15.75Z"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5 18C15.976 17.3014 15.2966 16.7344 14.5156 16.3438C13.7345 15.9533 12.8733 15.75 12 15.75C11.1267 15.75 10.2655 15.9533 9.48442 16.3438C8.70336 16.7344 8.02395 17.3014 7.5 18"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.5 20.25L4.5 3.75C4.5 3.33579 4.83579 3 5.25 3L18.75 3C19.1642 3 19.5 3.33579 19.5 3.75V20.25C19.5 20.6642 19.1642 21 18.75 21H5.25C4.83579 21 4.5 20.6642 4.5 20.25Z"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 6H9"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_807_3134">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 1 24 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ApartmentIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_807_3152)">
        <path
          d="M12 16.875C9.92893 16.875 8.25 15.1961 8.25 13.125C8.25 11.0539 9.92893 9.375 12 9.375C14.0711 9.375 15.75 11.0539 15.75 13.125C15.75 15.1961 14.0711 16.875 12 16.875Z"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.625 10.875C4.75149 10.8735 3.88972 11.0762 3.10843 11.4669C2.32714 11.8575 1.64794 12.4253 1.125 13.125"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.875 13.125C22.3521 12.4253 21.6729 11.8575 20.8916 11.4669C20.1103 11.0762 19.2485 10.8735 18.375 10.875"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.4 20.25C16.9061 19.2386 16.1381 18.3861 15.1834 17.7899C14.2286 17.1936 13.1256 16.8774 12 16.8774C10.8744 16.8774 9.77141 17.1936 8.81669 17.7899C7.86198 18.3861 7.09392 19.2386 6.60002 20.25"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.375 10.875C18.9444 10.8756 19.5022 10.7141 19.9832 10.4094C20.4643 10.1048 20.8487 9.6695 21.0915 9.15449C21.3344 8.63947 21.4256 8.06598 21.3546 7.50102C21.2837 6.93607 21.0534 6.40298 20.6907 5.96404C20.328 5.52511 19.8479 5.19845 19.3064 5.02225C18.765 4.84605 18.1845 4.82758 17.633 4.96899C17.0814 5.11041 16.5815 5.40587 16.1916 5.82085C15.8017 6.23583 15.538 6.7532 15.4313 7.3125"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.56873 7.3125C8.46196 6.7532 8.19824 6.23583 7.80836 5.82085C7.41848 5.40587 6.91856 5.11041 6.367 4.96899C5.81544 4.82758 5.23503 4.84605 4.69358 5.02225C4.15213 5.19845 3.67201 5.52511 3.30931 5.96404C2.94661 6.40298 2.71631 6.93607 2.64533 7.50102C2.57435 8.06598 2.66562 8.63947 2.90846 9.15449C3.15131 9.6695 3.53571 10.1048 4.01674 10.4094C4.49777 10.7141 5.05558 10.8756 5.62498 10.875"
          stroke="#333333"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_807_3152">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="matrix(-1 0 0 1 24 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const GlobalMaterialIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1372_9602)">
        <path
          d="M21 16.622V7.37824C20.9993 7.24472 20.9634 7.11375 20.8959 6.99853C20.8284 6.88331 20.7317 6.78793 20.6156 6.72199L12.3656 2.08137C12.2545 2.01719 12.1284 1.9834 12 1.9834C11.8716 1.9834 11.7455 2.01719 11.6344 2.08137L3.38437 6.72199C3.26827 6.78793 3.1716 6.88331 3.10411 6.99853C3.03663 7.11375 3.00072 7.24472 3 7.37824V16.622C3.00072 16.7555 3.03663 16.8865 3.10411 17.0017C3.1716 17.1169 3.26827 17.2123 3.38437 17.2782L11.6344 21.9189C11.7455 21.983 11.8716 22.0168 12 22.0168C12.1284 22.0168 12.2545 21.983 12.3656 21.9189L20.6156 17.2782C20.7317 17.2123 20.8284 17.1169 20.8959 17.0017C20.9634 16.8865 20.9993 16.7555 21 16.622V16.622Z"
          stroke="#374151"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.8969 6.99365L12.0844 11.9999L3.10315 6.99365"
          stroke="#374151"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.0844 12L12 22.0125"
          stroke="#374151"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1372_9602">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FeedbackIcon = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_807_3160)">
        <path
          d="M2.875 5.03125H20.125V17.25C20.125 17.4406 20.0493 17.6234 19.9145 17.7582C19.7797 17.893 19.5969 17.9688 19.4062 17.9688H3.59375C3.40313 17.9688 3.22031 17.893 3.08552 17.7582C2.95073 17.6234 2.875 17.4406 2.875 17.25V5.03125Z"
          stroke="#333333"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.125 5.03125L11.5 12.9375L2.875 5.03125"
          stroke="#333333"
          strokeWidth="1.4375"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_807_3160">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AboutIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_905_3114)">
        <path
          d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
          stroke="#27AE60"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.25 11.25H12V16.5H12.75"
          stroke="#27AE60"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.8125 9C12.4338 9 12.9375 8.49632 12.9375 7.875C12.9375 7.25368 12.4338 6.75 11.8125 6.75C11.1912 6.75 10.6875 7.25368 10.6875 7.875C10.6875 8.49632 11.1912 9 11.8125 9Z"
          fill="#27AE60"
        />
      </g>
      <defs>
        <clipPath id="clip0_905_3114">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
